var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector52(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 309,
    viewBox: "0 0 109 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.326 307.867C304.938 288.952 301.231 284.833 286.415 265.424C282.785 260.67 277.073 251.425 271.618 240.008C269.983 236.591 268.501 233.203 267.142 229.862C257.448 205.955 256.08 179.172 258.332 152.721C264.082 85.2321 227.55 24.3201 172.239 6.56282C116.833 -11.2229 55.3063 18.0372 25.2844 63.6974C21.3785 69.6387 4.14842 97.6745 1.60145 128.434C-6.46711 225.554 87.6091 264.361 230.752 293.745C233.537 294.314 246.795 296.488 249.608 296.877L328.336 307.877L328.326 307.867Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector52);
export default __webpack_public_path__ + "static/media/vector5-2.8cb3820a8d7eb8af3bfa07bbd6fce144.svg";
export { ForwardRef as ReactComponent };